import { render, staticRenderFns } from "./GroupedXLessonsList.vue?vue&type=template&id=54e44b1e&scoped=true&"
import script from "./GroupedXLessonsList.vue?vue&type=script&lang=ts&"
export * from "./GroupedXLessonsList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedXLessonsList.vue?vue&type=style&index=0&id=54e44b1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e44b1e",
  null
  
)

export default component.exports